module.exports = __webpack_public_path__ + "media/assets/images/flags/nr-27cbe082ef6a4ad19dc184aa36982d43.svg";